import { action, observable } from "mobx";
import {
  SearchProfile_Remove,
  SearchProfile_Submit,
  SearchProfiles_Search,
  SearchProfileType
} from "@graphql";
import { store } from "@store";
import locale from "@bonliva-crm/locale";
import { OkCancelDialogOptions } from "@containers";
import { FilterManager } from "@search";
import { SearchProfileFormInput } from "./AddSearchProfileDialog/SearchProfileFormInput";
import { Value } from "./utils";

export class SearchProfileSelectorStore {
  filterManager: FilterManager<any>;
  inputType: SearchProfileType;

  @observable selectedProfile: Value = null;
  @observable isOpenDialog = false;

  constructor(filterManager: FilterManager<any>, inputType: SearchProfileType) {
    this.filterManager = filterManager;
    this.inputType = inputType;
  }

  @action getInput = () => {
    const input = new SearchProfileFormInput();
    input.type = this.inputType;
    input.fields = JSON.stringify(this.filterManager.filter);
    return input;
  };

  @action toggleForm = () => {
    this.isOpenDialog = !this.isOpenDialog;
  };

  @action change = (fields: any, value: any) => {
    this.filterManager.updateFilter(fields, true);
    this.selectedProfile = value;
  };

  @action update = async (id: string) => {
    try {
      const data = this.getInput();

      await SearchProfile_Submit.func(
        { data, id },
        {
          refetchQueries: [SearchProfiles_Search.OperationName]
        }
      );
      store().snackbars.success(locale.Updated);
    } catch (e) {
      store().snackbars.error(`Error: ${e}`);
    }
  };

  @action remove = async (id: string) => {
    try {
      const options = new OkCancelDialogOptions(locale.deleteProfileConfirm);
      options.actions[0].title = locale.No;
      options.actions[1].title = locale.Yes;

      const res = await store().ui.confirmDialog.confirm(options);

      if (res === "ok") {
        await SearchProfile_Remove.func(
          { id },
          {
            refetchQueries: [SearchProfiles_Search.OperationName]
          }
        );

        this.selectedProfile = null;
        this.filterManager.clearFilter();

        store().snackbars.success(locale.Deleted);
      }
    } catch (e) {
      store().snackbars.error(`Error: ${e}`);
    }
  };
}
